import { TaxonomyListPage } from '../taxonomy/TaxonomyListPage.js';

export function CarFeatureListPage() {
  return (
    <TaxonomyListPage
      config={{
        title: 'Car Features',
        description: 'Global feature catalog (GPS, Bluetooth…).',
        apiPath: '/car-features',
        basePath: '/car-features',
        resource: 'carFeature',
        subject: 'CarFeature',
        entityLabel: 'feature',
      }}
    />
  );
}
